import { Flex, Text } from '@mediahuis/chameleon-react';
import { RouteYouIcon } from "../RouteYouIcon/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RouteYouBannerInline = _ref => {
  let {
    style,
    text
  } = _ref;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    bgColor: "colorGrey10",
    justifyContent: "space-between",
    px: 4,
    py: 2,
    style: style,
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      style: {
        gap: '8px'
      },
      children: [/*#__PURE__*/_jsx(RouteYouIcon, {
        icon: "plusBlack",
        height: "12px",
        width: "12px"
      }), /*#__PURE__*/_jsx(Text, {
        fontFamily: "system",
        size: "Caption2",
        children: text
      })]
    }), /*#__PURE__*/_jsx(RouteYouIcon, {
      icon: "routeYouLogo",
      height: "25px",
      width: "74px"
    })]
  });
};
export default RouteYouBannerInline;